import { Injectable } from '@angular/core';
import { Settings, SettingsData, SettingsService, SettingsStorage } from '@next/core-lib/settings';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PoultryContextKeys } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class SettingsServiceHelper {
  constructor(private settingsService: SettingsService) {}

  removeSettings(
    key: string,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = PoultryContextKeys.POULTRYNEXTREARING,
  ) {
    this.settingsService
      .removeSettings({
        contextName: context,
        key,
        storage,
        basedOnCurrentProfile: basedOnProfile,
        basedOnCurrentCustomer: basedOnCustomer,
        basedOnCurrentLocation: basedOnLocation,
      })
      .subscribe();
  }

  getSettings(
    key: string,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = PoultryContextKeys.POULTRYNEXTREARING,
  ): Observable<Settings[]> {
    return this.settingsService.getSettings({
      contextName: context,
      key,
      storage,
      basedOnCurrentProfile: basedOnProfile,
      basedOnCurrentCustomer: basedOnCustomer,
      basedOnCurrentLocation: basedOnLocation,
    });
  }

  getSingle<T>(
    defaultValue: T,
    key: string,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = PoultryContextKeys.POULTRYNEXTREARING,
  ): Observable<T> {
    return this.settingsService.getSingle<T>(
      {
        contextName: context,
        key,
        storage,
        basedOnCurrentProfile: basedOnProfile,
        basedOnCurrentCustomer: basedOnCustomer,
        basedOnCurrentLocation: basedOnLocation,
      },
      defaultValue,
    );
  }

  setSettings(
    key: string,
    data: SettingsData,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = PoultryContextKeys.POULTRYNEXTREARING,
  ) {
    this.settingsService
      .setSettings({
        contextName: context,
        key,
        storage,
        basedOnCurrentProfile: basedOnProfile,
        basedOnCurrentCustomer: basedOnCustomer,
        basedOnCurrentLocation: basedOnLocation,
        data,
      })
      .subscribe();
  }

  setSettingsAndGetId(
    key: string,
    data: SettingsData,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = PoultryContextKeys.POULTRYNEXTREARING,
  ): Observable<string | number> {
    return this.settingsService
      .setSettings({
        contextName: context,
        key,
        storage,
        basedOnCurrentProfile: basedOnProfile,
        basedOnCurrentCustomer: basedOnCustomer,
        basedOnCurrentLocation: basedOnLocation,
        data,
      })
      .pipe(map((s) => s.settingsId));
  }
}
